// extracted by mini-css-extract-plugin
export var divider = "_1p-0";
export var dividerText = "_1p-2";
export var dividerVertical = "_1p-1";